import { useQuery } from 'react-query';
import { getScope3 } from '../../ ../../../../../../apiCallFunctions/report';
import { StateDTO } from '../../../../../models/GeneralDTO';
import { useSelector } from 'react-redux';

export const useGetScope3 = (currentDate: string[]) => {
  const { id: currentProjectId } = useSelector(
    (state: StateDTO) => state.projects.currentProject
  );
  return useQuery({
    queryKey: ['getScope3', currentDate],
    retry: false,
    enabled: currentDate.length !== 0,
    refetchOnWindowFocus: false,
    queryFn: () => getScope3(currentProjectId, currentDate),
  });
};
